/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ITicketAttachments } from './Attachment';
import { ICustomFieldTicket } from './CustomFieldTicketValue';
import { Ticket } from '@touchplan/common';

export class TicketMeta {
	// public exceptionDays?;
	// public constraintIdx?: string;
	constructor(
		public ticket: Ticket,
		public timelineIdx?: string,
		public customFieldTicketValues?: ICustomFieldTicket,
		public ticketAttachmentsData?: ITicketAttachments
	) {}
}
